import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-ponderacion-notas-previas',
  templateUrl: './modal-ponderacion-notas-previas.component.html',
  styleUrls: ['./modal-ponderacion-notas-previas.component.scss']
})
export class ModalPonderacionNotasPreviasComponent {
  @Output() cstmFn = new EventEmitter<void>()

  childFunction() {
    this.cstmFn.emit()
  }

}
